import { apiGet } from '../api'

export const get_flagged_learners = () => {
  return apiGet({
    endpoint: 'attendance/get_flagged_learners'
  })
}
